import _objectSpread from "E:/work/\u521B\u5947/\u95EE\u5377/answer-h5-new/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { get, post } from './request';
var token = localStorage.getItem('token');
// 获取个人答题信息
export var getPersonInfo = function getPersonInfo(data) {
  return get('/question_active/active_user', data);
};

// 获取个人答题明细
export var getUserScore = function getUserScore(data) {
  return get('/answer/score_user', data);
};

// 获取个人答题排名
export var getUserRank = function getUserRank(data) {
  return get('/answer/rank_user', data);
};

// 获取用户当前卷子信息
export var getUserCurrentQuesInfo = function getUserCurrentQuesInfo(data) {
  return get('/question_active/active_setting', data);
};

// 获取当前绑定模板信息
export var getBindModuleInfo = function getBindModuleInfo(data) {
  return get('/question_active/module_info', data);
};

// 获取当前绑定的一级个人信息
export var getBindUserFirstSelectionList = function getBindUserFirstSelectionList(data) {
  return get('/user/list_first', data);
};

// 获取当前绑定的二级个人信息
export var getBindUserSecondSelectionList = function getBindUserSecondSelectionList(data) {
  return get('/user/list_second', data);
};

// 获取当前绑定的三级个人信息
export var getBindUserThirdSelectionList = function getBindUserThirdSelectionList(data) {
  return get('/user/list_third', data);
};

// 提交个人信息
export var submitPersonInfo = function submitPersonInfo(data) {
  return post('/user/save', data);
};

// 修改个人信息
export var updatePersonInfo = function updatePersonInfo(data) {
  return post('/user/update', data);
};

// 获取个人提交信息
export var getUserSelectionInfo = function getUserSelectionInfo(data) {
  return get('/user/info', data);
};

// 获取单位排名
export var getUnitRank = function getUnitRank(data) {
  return get('/user/rank_level', data);
};

// 获取挂失列表
export var getUserLossRecordList = function getUserLossRecordList(data) {
  return get('/answer/loss_record', _objectSpread({
    token: token
  }, data));
};

// 获取挂失状态
export var getUserLossStatus = function getUserLossStatus(data) {
  return get('/answer/loss_status', data);
};

// 获取用户总积分
export var getUserTotalScore = function getUserTotalScore(data) {
  return get('/question_active/score_total', data);
};

// 获取用户积分历史
export var getUserScoreHistory = function getUserScoreHistory(data) {
  return get('/question_active/score_log', data);
};

// 获取个人成绩
export var getUserAchievements = function getUserAchievements(data) {
  return get('/question_active/rank_person', data);
};

// 获取抽奖信息链接
export var getDrawInfo = function getDrawInfo(data) {
  return get('/question_active/lottery_info', data);
};

// 抽奖 活动信息
export var fetchActivityInfo = function fetchActivityInfo(data) {
  return get('/activity/queryDetails', data);
};

// 抽奖
export var updateRecordUser = function updateRecordUser(data) {
  return put('/record/updateRecordUser', data);
};